angular.module('unica_partner.partner_services')

.factory('PartnerCreateService', function ($http, getBaseApiURL) {

	var partnerCreateService = {};

	partnerCreateService.create = function (partnerData)
	{
		return $http({
			method: 'post',
			url: getBaseApiURL + '/partner/create',
			data: partnerData
		}).then(function(result) {

			if ( result ) {
				return result.data.partner;
			}

		});
	};

	return partnerCreateService;
});